module.exports = __webpack_public_path__ + "static/pass-verified-63b081a200c437eae3e94637b77e39c9.png";